export const GET_ASSIGNMENTS = 'GET_ASSIGNMENTS';
export const EDIT_ASSIGNMENT = 'EDIT_ASSIGNMENT';
export const SUBMIT_ASSIGNMENT_CODE = 'SUBMIT_CODE_ASSIGNMENT';
export const GO_TO_NEXT = 'GO_TO_NEXT';
export const RESET_ASSIGNMENT_CODE = 'RESET_ASSIGNMENT_CODE';